import Game from '../Game';

export function getFreeOrCost(value: number, count: number): string {
    if (count > 0) {
        return `${Game.locale.getText('Free')} x ${count}`;
    } else {
        return value.toString();
    }
}

export function convertVersionToFloat(value: string): number {
    const versions: string[] = value.split('.');

    if (versions.length === 2) return Number(value);

    let modifiedVersion: string = `${versions[0]}.${versions[1]}`;
    for (let i = 2; i < versions.length; i++) {
        modifiedVersion = `${modifiedVersion}0${versions[i]}`;
    }

    return Number(modifiedVersion);
}
